/**
 * Profil candidat (cahier §4, TODO phase 8). Règles partagées API / portails.
 */
export const GENDERS = { F: 'Féminin', M: 'Masculin' };
export const ID_DOCUMENT_TYPES = {
    cni: {
        label: 'Carte nationale d’identité (CEDEAO)',
        regex: /^\d{13,17}$/,
        hint: '13 à 17 chiffres',
    },
    passport: { label: 'Passeport', regex: /^[A-Z0-9]{6,12}$/, hint: '6 à 12 lettres ou chiffres' },
};
/* ------------------------------------------------------------------ */
/* Copie numérisée de la pièce d'identité (profil)                     */
/* ------------------------------------------------------------------ */
/** Faces attendues : recto et verso pour la carte d'identité, une page pour le passeport. */
export const ID_SCAN_SIDES = {
    front: { label: 'Recto', hint: 'Face avec votre photo et le numéro de la carte.' },
    back: { label: 'Verso', hint: 'Face arrière de la carte.' },
    page: {
        label: 'Page d’identité',
        hint: 'Page du passeport avec votre photo et les lignes de lecture en bas.',
    },
};
export const ID_SCAN_REQUIRED = {
    cni: ['front', 'back'],
    passport: ['page'],
};
export const ID_SCAN_FORMATS = ['pdf', 'jpg', 'png'];
export const ID_SCAN_MAX_MB = 5;
/** Faces manquantes (ou pas encore vérifiées) pour le type de pièce choisi. */
export function missingIdScans(type, scans) {
    if (!type)
        return [];
    return ID_SCAN_REQUIRED[type].filter((side) => !scans.some((s) => s.side === side && s.documentType === type && s.scanStatus === 'clean'));
}
/** Les 14 régions administratives du Sénégal. */
export const SENEGAL_REGIONS = [
    'Dakar',
    'Diourbel',
    'Fatick',
    'Kaffrine',
    'Kaolack',
    'Kédougou',
    'Kolda',
    'Louga',
    'Matam',
    'Saint-Louis',
    'Sédhiou',
    'Tambacounda',
    'Thiès',
    'Ziguinchor',
];
/**
 * Champs d'identité : figés dès la première candidature soumise (phase 9), car
 * ils fondent la recevabilité et les documents officiels. Une correction passe
 * alors par une demande motivée traitée par un agent.
 */
export const CANDIDATE_IDENTITY_FIELDS = [
    'lastName',
    'firstName',
    'birthDate',
    'birthPlace',
    'gender',
    'idDocumentType',
    'idDocumentNumber',
];
/** Champs exigés pour un profil complet (prérequis du dépôt de dossier). */
export const CANDIDATE_REQUIRED_FIELDS = [
    'lastName',
    'firstName',
    'birthDate',
    'birthPlace',
    'gender',
    'nationality',
    'idDocumentType',
    'idDocumentNumber',
    'phone',
    'address',
    'city',
    'region',
];
export const CANDIDATE_FIELD_LABELS = {
    lastName: 'Nom',
    firstName: 'Prénom(s)',
    birthDate: 'Date de naissance',
    birthPlace: 'Lieu de naissance',
    gender: 'Sexe',
    nationality: 'Nationalité',
    idDocumentType: 'Type de pièce d’identité',
    idDocumentNumber: 'Numéro de pièce d’identité',
    phone: 'Téléphone',
    address: 'Adresse',
    city: 'Ville',
    region: 'Région',
    photo: 'Photo d’identité',
    idScans: 'Copie de la pièce d’identité',
};
/* ------------------------------------------------------------------ */
/* Doublons (cahier §4.5)                                              */
/* ------------------------------------------------------------------ */
export const DUPLICATE_RULES = {
    id_document: {
        label: 'Même numéro de pièce d’identité',
        description: 'Type et numéro de pièce identiques (après normalisation).',
    },
    name_birth: {
        label: 'Mêmes nom, prénoms et date de naissance',
        description: 'Comparaison sans accents, majuscules ni espaces superflus.',
    },
    name_birth_place: {
        label: 'Mêmes nom, prénoms, date et lieu de naissance',
        description: 'Variante plus stricte de la règle précédente.',
    },
};
export const DUPLICATE_STATUSES = {
    open: 'À examiner',
    confirmed: 'Doublon confirmé',
    dismissed: 'Faux positif',
};
/** « Ndèye  Fatou » et « NDEYE FATOU » → « ndeye fatou ». */
export function normalizeName(value) {
    return (value ?? '')
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
}
/** Numéro de pièce : majuscules et chiffres seulement. */
export function normalizeIdNumber(value) {
    return (value ?? '').toUpperCase().replace(/[^A-Z0-9]/g, '');
}
/** Masque un numéro de pièce pour l'affichage et le journal (4 derniers caractères). */
export function maskIdNumber(value) {
    if (!value)
        return null;
    return value.length <= 4
        ? '••••'
        : `${'•'.repeat(Math.min(value.length - 4, 8))}${value.slice(-4)}`;
}
//# sourceMappingURL=candidates.js.map